<template>
    <div style="height: 100%">

        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.iaTitle" style="width: 140px;" size="small " placeholder="请输入标题"
                        clearable></el-input>
                    <el-select size="small" v-model="formDatas.iuId" clearable @change="partserch" placeholder="请选择用户"
                        v-if="iuPost == 2" style="width: 130px">
                        <el-option v-for="(item, index) in userarr" :label="item.iuName" :value="item.iuId"
                            :key="index"></el-option>

                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-dropdown v-if="postid == 2" size="small" split-button type="warning"
                        style="margin-left: 10px;width: 100px;" @click="Out()" @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-row>
            </div>
            <div style="width: 15%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">

                    <el-dropdown size="small" split-button type="warning" style="width: 100%;" trigger="click"
                        @click="BoxOpen()" @command="BoxOpen">
                        新增录音
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;margin: 5px 0;"
                                command="1">批量新增录音</el-dropdown-item>
                            <el-dropdown-item style="background-color: #E6A23C;color: white;margin: 5px 0;" command="2"
                                v-if="postid == 2">批量导出录音</el-dropdown-item>
                        </el-dropdown-menu>

                    </el-dropdown>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="iaId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%;background-image: url();"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑录音' : '新增录音'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="录音标题(格式:日期-岗位-姓名-反馈)" prop="iaTitle">
                                <el-input v-model="form.iaTitle" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="录音地址" prop="iaPath">
                                <my-upload ref="OtherImgupload" @fileChange="OtherImgChange" :filearr="OtherImgfileList"
                                    :limit="OtherImglimit" style="margin: 10px 5px 5px;" type="text"
                                    accept=".mp3,.flac,.ogg,.cd,.cda,.ape,.asf,.rm,
                                .mov,.amr,.realaudio,.pcm,.avi,.3gp,.mkv,.vbr,.vqf,.aiff,.aif,.oggvorbis,.au,.m4a,.aac,.x-m4a,.mpeg,.mpeg-4,.adts,.wav,.wave,.wma,.midi,.mid"></my-upload>
                                <el-input disabled v-model="form.iaPath" style="width: 50%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="备注" prop="iaPath">
                                <el-input v-model="form.iaDes" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <el-dialog title="批量新增(文件名称:日期-岗位-姓名-反馈)" :visible.sync="IsAdd" width="70%" top="15vh">
                <div style="height: 40vh;">

                    <div>
                        <my-upload ref="OtherImgupload" @fileChange="OtherImgChange" :filearr="OtherImgfileList"
                            :limit="addLimit" style="margin: 10px auto;width: 95%;max-height: 40vh;overflow-y: scroll;"
                            type="text" accept=".mp3,.flac,.ogg,.cd,.cda,.ape,.asf,.rm,
                                .mov,.amr,.realaudio,.pcm,.avi,.3gp,.mkv,.vbr,.vqf,.aif,.oggvorbis,.au">
                        </my-upload>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="bulkAdditionsClose">取 消</el-button>
                    <el-button type="primary" @click="bulkAdditions">确定</el-button>
                </div>
            </el-dialog>

            <div style="width: 86%;position:fixed;bottom: 5px;left: 12%;background-color: white;
             box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)" v-if="audioShow">
                <i class="el-icon-close" style="margin-left: 98%;size: 25px;" @click="playbackRate = 1.0,audioShow = false" ></i>
                <div style="width: 98%;display: flex;flex-direction: row-reverse;">
                    <el-button type="success" size="mini" @click="increaseSpeed">增加播放速度</el-button>
                     <div style="margin: 0 15px;">  {{ playbackRate.toFixed(1) }} </div>
                    <el-button type="danger" size="mini" @click="decreaseSpeed">减少播放速度</el-button>
                    <el-button style="margin-right: 15px;" type="primary" size="mini" @click="restoreSpeed">恢复播放速度</el-button>
                </div>
                <aplayer ref="aplayer" controls :music="audio[0]" fixed v-if="audio.length > 0" autoplay
                    @ended="onEnded" />
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import saveAs from 'file-saver';
import config from '../../api/env.js';
var FileSaver = require('file-saver');
import { getIvAudioList, addIvAudio, updateIvAudio, deleteIvAudio, getIvUserList } from "../../api/api";
import aplayer from "vue-aplayer";
export default {
    name: "",
    components: {
        aplayer
    },
    data() {
        return {
            playbackRate: 1.0, // 初始播放速度为1
            postid: '',
            audioSuccessNum: 0,
            audioFIle: [],
            IsAdd: false,
            userarr: [],
            audioShow: false,
            audio: [],
            OtherImglimit: 1,
            addLimit: 9,
            OtherImgfileList: [],
            key: 'iaId',
            dialog: false,
            edit: false,
            form: {
                iaId: '',
                iaTitle: '',
                iaPath: '',
                iaDes: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",

                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "iuName",
                    key: "iuName",
                    title: "面试官",
                    align: "center",
                    edit: false,
                },
                {
                    field: "iaTitle",
                    key: "iaTitle",
                    title: "标题",
                    align: "center",
                    // edit: true,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <span>{row.iaTitle}</span>
                                {
                                    row.iaExistsEos == 1 ? <span style="color:red;">(文件损坏,请重新上传)</span> : ''
                                }

                            </span>
                        );
                    },
                },
                {
                    field: "iaDes",
                    key: "iaDes",
                    title: "备注",
                    align: "center",
                    edit: true,
                },

                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.iaPath != '***' ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.audioClick(row)}
                                    >
                                        播放
                                    </el-button> : ''
                                }
                                {
                                    row.iaPath != '***' ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button> : ''
                                }

                                {
                                    this.postid == 2 && row.iaExistsEos == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.Download(row)}
                                    >
                                        下载
                                    </el-button> : ''
                                }

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                iuId: '',
                iaTitle: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.postid = localStorage.getItem('iuPost')
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.iuPost = localStorage.getItem("iuPost");
        getIvUserList({ iuPost: 1 }).then(res => {
            this.userarr = res.data
        })
        this.getList();
    },
    mounted() {

    },
    methods: {
        restoreSpeed() {
            this.playbackRate = 1.0;
            this.setPlaybackRate(this.playbackRate);
        },
        increaseSpeed() {
            this.playbackRate += 0.1; // 增加0.1倍
            this.setPlaybackRate(this.playbackRate);
        },
        decreaseSpeed() {
            this.playbackRate -= 0.1; // 减少0.1倍
            this.setPlaybackRate(this.playbackRate);
        },
        setPlaybackRate(rate) {
            if (this.$refs.aplayer) {
                const audio = this.$refs.aplayer.audio;
                if (audio) {
                    audio.playbackRate = rate;
                }
            }
        },
        Out(e) {
            if (e) {
                const bulkdata = {
                    //    iaIds: this.selectedRowKeysCollection.toString(),
                    iuId: this.formDatas.iuId,
                    iaTitle: this.formDatas.iaTitle,
                    exportType: 1,
                }
                this.openLoading();
                var s = qs.stringify(bulkdata);
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/iv-audio/exportIvAudio',
                    data: s,
                    withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('iuId')
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '录音.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            } else {
                if (this.selectedRowKeysCollection.length === 0) return alertWarn('请选择您要导出的数据！');

                //    //console.log(selection.join());
                const bulkdata = {
                    iaIds: this.selectedRowKeysCollection.toString(),
                    iuId: this.formDatas.iuId,
                    iaTitle: this.formDatas.iaTitle,
                    exportType: 2,
                }
                this.openLoading();
                var s = qs.stringify(bulkdata);
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/iv-audio/exportIvAudio',
                    data: s,
                    withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('iuId')
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '录音.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });
                        //    that.BulkClose()
                    }
                })
            }
        },
        Download(row) {
            this.openLoading()
            const suffix = row.iaTitle + '.' + row.iaPath.substring(row.iaPath.lastIndexOf('.') + 1)
            //console.log(suffix);
            FileSaver.saveAs(row.iaPath, suffix)
            // let url = window.URL.createObjectURL(new Blob([row.iaPath]))
            // // 生成一个a标签
            // let link = document.createElement('a')
            // link.style.display = 'none'
            // link.href = url
            // link.download = row.iaTitle
            // document.body.appendChild(link)
            // link.click()
            // link.remove()
            this.loadings.close()
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        bulkAdditionsClose() {
            this.IsAdd = false;
            this.form.iaPath = '';
            this.form.iaTitle = ''
            setTimeout(() => {

                this.$refs.OtherImgupload.fileAllRemove()
                this.OtherImgfileList = [];

            }, 10)
        },
        bulkAdditions() {
            this.$confirm("是否确定要批量新增吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    //console.log(this.audioFIle);
                    this.audioFIle.forEach((item, index) => {
                        const s = {
                            iaTitle: item.fileName.substring(0, item.fileName.lastIndexOf('.')),
                            iaPath: item.fileurl
                        };
                        //console.log(s);

                        addIvAudio(s).then(res => {
                            this.audioSuccessNum += 1;
                            //console.log(this.audioSuccessNum);
                            if (this.audioSuccessNum == this.audioFIle.length) {
                                //console.log('成功');
                                this.audioSuccessNum = 0
                                this.$message({
                                    type: "success",
                                    message: "上传成功!",
                                });
                                this.bulkAdditionsClose();
                                this.getList()
                            }
                        })


                    })

                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        onEnded() {

            this.audio = [];
            this.audioShow = false;
        },
        audioClick(row) {

            this.audio = []
            const s = {
                title: row.iaTitle,
                artist: row.iuName,
                src: row.iaPath,
                pic: 'http://eos-shanghai-2.cmecloud.cn/aojv/interview/682c50e8278747d280437f3a438b990e.png', // prettier-ignore
                lrc: '',
            }
            this.audio.push(s);
            this.audioShow = true;
        },
        OtherImgChange(file) {
            if (file.length > 1) {
                this.audioFIle = file
            } else {
                this.audioFIle = file
                this.$set(this.form, 'iaPath', file[0].fileurl);
                this.$set(this.form, 'iaTitle', file[0].fileName.substring(0, file[0].fileName.lastIndexOf('.')));
                this.$message({
                    type: "success",
                    message: "上传成功!",
                });
            }

        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteIvAudio({ iaId: row.iaId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {

                const obj = {
                    OtherImgfileList: 'iaPath',

                }
                for (let item in obj) {
                    for (let key in data) {
                        if (key == obj[item] && data[key]) {
                            //console.log(data[obj[item]]);
                            const img = {
                                name: data[obj[item]],
                                url: data[obj[item]],
                            }
                            this.$set(this[item], 0, img)
                        }
                    }
                }
            });
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addIvAudio(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateIvAudio(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        BoxOpen(e) {
            if (!e) {
                this.dialog = true;

            } else if (e == 1) {
                this.IsAdd = true;
            } else {
                if (this.selectedRowKeysCollection.length == 0) {
                    this.$message({
                        showClose: true,
                        message: "请选择",
                        type: 'danger'
                    });
                } else {
                    this.openLoading()
                    this.tableData.forEach((data, id) => {
                        this.selectedRowKeysCollection.forEach((item, index) => {
                            if (data.iaId == item) {
                                const suffix = data.iaTitle + '.' + data.iaPath.substring(data.iaPath.lastIndexOf('.') + 1)
                                //console.log(suffix);
                                FileSaver.saveAs(data.iaPath, suffix)

                            }
                            if (id == this.tableData.length - 1) {
                                this.loadings.close()
                            }
                        })
                    })

                }
            }

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            setTimeout(() => {

                this.$refs.OtherImgupload.fileAllRemove()
                this.OtherImgfileList = [];

            }, 10)
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.iaId = row.iaId
                    //console.log(jsonObj);
                    updateIvAudio(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getIvAudioList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getIvAudioList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getIvAudioList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.el-dialog__body {
    padding: 5px 0;
}

.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>